import React from 'react';
import { clsx } from 'clsx';

export interface SwitchProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  label?: string;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'warning';
}

const Switch = React.forwardRef<HTMLInputElement, SwitchProps>(
  ({ label, color = 'primary', className, checked, ...props }, ref) => {
    const colorClasses = {
      primary: 'bg-primary',
      secondary: 'bg-secondary',
      success: 'bg-success',
      error: 'bg-error',
      warning: 'bg-warning',
    };

    return (
      <label className={clsx('inline-flex items-center gap-2 cursor-pointer', className)}>
        <div className="relative">
          <input
            ref={ref}
            type="checkbox"
            className="sr-only peer"
            checked={checked}
            {...props}
          />
          <div
            className={clsx(
              'w-11 h-6 rounded-full transition-colors',
              'peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-offset-2',
              {
                'bg-gray-200': !checked,
                [`${colorClasses[color]} peer-focus:ring-${color}-500`]: checked,
              }
            )}
          />
          <div
            className={clsx(
              'absolute left-1 top-1 bg-white w-4 h-4 rounded-full transition-transform',
              {
                'translate-x-5': checked,
              }
            )}
          />
        </div>
        {label && <span className="text-sm font-medium text-gray-900">{label}</span>}
      </label>
    );
  }
);

Switch.displayName = 'Switch';

export default Switch;

